import Box from "@mui/material/Box";

import MobileDrawer from "./Drawers/MobileDrawer";
import DesktopDrawer from "./Drawers/DesktopDrawer";

const Sidebar = (props) => {
  return (
    <Box>
      <MobileDrawer />
      <DesktopDrawer />
    </Box>
  );
};
export default Sidebar;
